import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import "./index.css";
import { UserContext } from "../../../../../../App";
import { Button, CircularProgress, Modal, Box } from "@mui/material";
import { getSellingprice } from "../../../../../../config/Services";
// TODO(useAddToCart): remaining direct calls can be migrated to useAddToCart hook
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { searchTextRes, searchTextRespaymnet } from "../../redux/Actions/paginationActions";
import breakpoints from "assets/theme/base/breakpoints";
import { useSelector } from "react-redux";
import useGetDevice from "../../../hooks/useGetDevice";
import { checkGtinType, checkUnitType } from "../../utils/cartUtils";
import StyledButton from "../custom/StyledButton";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useWeighingItemModal from "../../../hooks/useWeighingItemModal";
import { removeFromLocalStorage } from "../../../../../../utils/localStorageHelpers";
import { useAddToCart } from "../../../hooks/useAddToCart";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";
import CartItemDrawer from "../cartItemTable/Drawer/CartItemDrawer/CartItemDrawer";

const DropDownModal = () => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { addItemWithCheck, addItemDirect } = useAddToCart();
  const { findWeighingItem, renderWeighingModal } = useWeighingItemModal();
  const { particularCategoryItems } = useContext(UserContext);
  const dispatch = useDispatch();
  const [mrps, setMrps] = useState([]);
  const [sellingUnit, setSellingUnit] = useState("");
  const [selectedMrp, setSelectedMrp] = useState("");
  const [SelectedSellingPrice, setSelectedSellingPrice] = useState("");
  const [brandName, setBrandName] = useState("");
  const [packagingType, setPackagingType] = useState("");
  const [variantName, setVariantName] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [selectedGtin, setSelectedGtin] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const { openModalTwoway, setOpenModalTwoway } = useContext(UserContext);
  const { setanimationBox } = useContext(UserContext);
  const { cartItems, setItemgtin, gtinItem, setSearchText, setOfferFound } = useContext(UserContext);
  const [
    addItemThroughParticularCategoryItemLoader,
    setAddItemThroughParticularCategoryItemLoader,
  ] = useState(null);
  const { setCartItems } = useContext(UserContext);
  const { setSubTotal } = useContext(UserContext);
  const { setTotal } = useContext(UserContext);
  const { setCgst } = useContext(UserContext);
  const { highlightMrp, setHighlightMrp } = useContext(UserContext);
  const { setSgst, setCess, setHighlightedCartProductId } = useContext(UserContext);
  const CartId = localStorage.getItem("CartId");
  const [open, setOpen] = useState(false);
  const [responseCartTimes, setResponseCartTimes] = useState(
    JSON.parse(localStorage.getItem("responseCartTimes")) || []
  );

  const [addItemResponseTime, setAddItemResponseTime] = useState(
    JSON.parse(localStorage.getItem("addItemResponseTime")) || []
  );

  const appDrawer = useSelector((state) => state.pagination.appDrawer);
  const { color, setColor } = useContext(UserContext);

  const [couponApplied, setCouponApplied] = useState("0");
  const [appliedState, setAppliedState] = useState(false);
  const [detailItem, setDetailItem] = useState(null); // product info drawer
  const [offerData, setOfferData] = useState(null);

  //add a item to cart

  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  // new cart apis changes — error handling delegated to useAddToCart hook
  const increseItemQuantityTroughParticularCategory = (
    gtin,
    name,
    index,
    packaging_type,
    sellingUnit
  ) => {
    setAddItemThroughParticularCategoryItemLoader(index);
    let payload = {
      gtin: gtin,
      cartId: CartId,
      locationId: locId,
      orgId: orgId,
    };
    const start = new Date().getTime();
    if (findWeighingItem(gtin, name, packaging_type, sellingUnit)) {
      setAddItemThroughParticularCategoryItemLoader(false);
      return;
    }
    addItemWithCheck(payload, {
      onBeforeError: () => {
        setAddItemThroughParticularCategoryItemLoader(false);
        setOpen(false);
        dispatch(searchTextRespaymnet(""));
      },
      onBatchSelect: (dataArr) => {
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        setVariantName(dataArr?.[0]?.variantName);
        setVendorId(dataArr?.[0]?.vendorId);
        setBrandName(dataArr?.[0]?.brand);
        setSellingUnit(dataArr?.[0]?.sellingUnit);
        setExpiryDate(dataArr?.[0]?.expiryDate || "");
        setPackagingType(dataArr?.[0]?.packagingType);
        setMrps(dataArr);
        setOfferData(dataArr?.[0]?.offers);
        setSelectedMrp(dataArr?.[0]?.mrp);
        setSelectedSellingPrice(dataArr?.[0]?.sellingPrice);
        setBatchNo(dataArr?.[0]?.batchNum);
        setPurchasePrice(dataArr?.[0]?.purchasePrice || "");
        setSelectedGtin(dataArr?.[0]?.gtin);
        setSelectedProduct(name);
        setOpen(false);
        setOpenModalTwoway(true);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(dataArr[0].sellingPrice);
      },
      onSuccess: (response) => {
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        // Cart state (cartItems, billing, offerFound) applied by useAddToCart hook
        setCouponApplied(response?.billing?.appliedCoupon);
        localStorage.removeItem("loyaltyPoints");
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setSelectedSellingPrice("");
        setBatchNo("");
        setPurchasePrice("");
        setSelectedGtin("");
        setSelectedProduct("");
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(response?.cartProducts?.[0]?.sellingPrice);
        setOpen(false);
        dispatch(searchTextRespaymnet(""));
        setSearchText("");
      },
    });
  };

  const isProfilerOn =
    // useMemo(() => {
    localStorage.getItem("profilerSwitch") === "true";
  // }, []);

  const addItem = (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    offer,
    brandName,
    packagingType,
    variantName,
    vendorId,
    expiryDate,
    sellingUnit
  ) => {
    setOpenModalTwoway(false);
    setHighlightMrp(sp);
    const start = new Date().getTime();
    let payload = {
      cartId: CartId,
      gtin: selectedGtin || gtin,
      sellingPrice: sp,
      locationId: locId,
      mrp: mrp,
      inventoryChecks: "NO",
      batchNo: batchNo,
      purchasePrice: purchasePrice,
      data: offer?.length > 0 ? true : false,
      sellingUnit: sellingUnit,
      expiryDate: expiryDate?.split("+")[0],
      variantName: variantName,
      vendorId: vendorId,
      packagingType: packagingType,
      brandName: brandName,
    };

    // Error handling (stale cart, no cart, generic) delegated to useAddToCart hook
    addItemDirect(payload, cartItems, {
      onBeforeError: () => {
        setAddItemThroughParticularCategoryItemLoader(null);
        setOpen(false);
        dispatch(searchTextRespaymnet(""));
        dispatch(searchTextRes(""));
      },
      onSuccess: (cartData) => {
        //cart-response-time
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...responseCartTimes,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("responseCartTimes", JSON.stringify(updatedResponseTimes));
          setResponseCartTimes(updatedResponseTimes);
        }
        // Cart state (cartItems, billing, offerFound) applied by useAddToCart hook
        // Highlight the newly added product (use same sort as hook for consistency)
        const sortedProducts = [...(cartData?.cartProducts || [])].sort((a, b) =>
          (b.modifiedDate || b.createdDate || "").localeCompare(a.modifiedDate || a.createdDate || "")
        );
        if (sortedProducts?.[0]?.cartProductId) {
          setHighlightedCartProductId(sortedProducts[0].cartProductId);
          setTimeout(() => setHighlightedCartProductId(null), 2000);
        }
        localStorage.removeItem("loyaltyPoints");
        setCouponApplied(cartData?.billing?.appliedCoupon);
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setSelectedSellingPrice("");
        setBatchNo("");
        setPurchasePrice("");
        setSelectedGtin("");
        setSelectedProduct("");
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
        setOpen(false);
        dispatch(searchTextRespaymnet(""));
        dispatch(searchTextRes(""));
        setSearchText("");
      },
    });
  };

  useEffect(() => {
    if (particularCategoryItems.length === 0) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [particularCategoryItems]);

  const handleClose = () => {
    setOpen(false);
    dispatch(searchTextRespaymnet(""));
  };

  const handleModalClose = () => {
    setOpenModalTwoway(false);
    setAddItemThroughParticularCategoryItemLoader(null);
  };

  const handlePrice = (mrp, sp, batchNo, purchasePrice, offer) => {
    setSelectedMrp(mrp);
    setSelectedSellingPrice(sp);
    setBatchNo(batchNo);
    setPurchasePrice(purchasePrice);
    setOfferData(offer);
  };

  //button focus function:
  const searchTextValueI = useSelector((state) => state.pagination.searchTextI);

  const handleCloseDropdown = () => {
    dispatch(searchTextRespaymnet(""));
  };

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "c" && e.altKey) {
        e.preventDefault();
        handleCloseDropdown();
      }
    });
  }, []);

  return (
    <>
      {renderWeighingModal()}

      {/* Product detail drawer — opened from the info icon on each row */}
      {detailItem && (
        <CartItemDrawer
          cartItemModalOpen={!!detailItem}
          setCartItemModalOpen={(v) => { if (!v) setDetailItem(null); }}
          cartItemData={detailItem}
        />
      )}

      {particularCategoryItems.length === 0 ? (
        <></>
      ) : (
        <div
          className={isMobile ? "DropDownModal-mobile" : "DropDownModal-web"}
          display={open ? "block" : "none"}
          style={{ ...(isMobile && { width: appDrawer ? "calc(100vw - 85px)" : "100%" }) }}
        >
          {particularCategoryItems?.map((item, index) => (
            <div
              key={item?.variant?.barcodes[0]}
              id="myDropDownFocus"
              className={isMobile ? "DropDownModal-mobile-wrapper" : "DropDownModal-wrapper-box"}
            >
              {/* Clickable area (image + text) — opens product detail drawer */}
              <div
                className="dropdown-clickable-area"
                role="button"
                tabIndex={0}
                title="View product details"
                onClick={() => setDetailItem({
                  gtin: item?.variant?.barcodes[0],
                  productName: item?.variant?.name || item?.name,
                  productImage:
                    item?.variant?.images?.front ||
                    item?.variant?.images?.back  ||
                    item?.variant?.images?.left  ||
                    null,
                })}
                onKeyDown={(e) => e.key === "Enter" && setDetailItem({
                  gtin: item?.variant?.barcodes[0],
                  productName: item?.variant?.name || item?.name,
                  productImage:
                    item?.variant?.images?.front ||
                    item?.variant?.images?.back  ||
                    item?.variant?.images?.left  ||
                    null,
                })}
              >
                <div className="DropDownModal-wrapper-img-box" key={item?.variant?.barcodes[0]}>
                  <img
                    className="DropDownModal-wrapper-img-box-inner"
                    src={
                      item?.variant?.images?.front ||
                      item?.variant?.images?.back ||
                      item?.variant?.images?.left ||
                      item?.variant?.images?.right ||
                      item?.variant?.images?.top ||
                      item?.variant?.images?.bottom ||
                      item?.variant?.images?.top_left ||
                      item?.variant?.images?.top_right ||
                      "https://tse4.mm.bing.net/th?id=OIP.mPwk4FItjNeb2Oaq8F1u9QHaGE&pid=Api&P=0"
                    }
                    alt="err"
                  />
                </div>
                <div className="dropdownModal-text-wrapper-box">
                  <div className="dropdownModal-text-wrapper-box-inner-box">
                    <h3>{item?.variant?.name || item?.name}</h3>
                    <p className="gtin-text">({item?.variant?.barcodes[0]})</p>
                  </div>
                  <div>
                    <b className="mrp-wrapper-dropdownText"> {getStoreCurrencySymbol()}{item?.variant?.inventorySync?.mrp}</b>
                  </div>
                </div>
              </div>

              <div className="dropdown-btn-wrapper-box">
                <StyledButton
                  id="myDropDownFocus"
                  size="medium"
                  disabled={
                    !!addItemThroughParticularCategoryItemLoader ||
                    addItemThroughParticularCategoryItemLoader === 0
                  }
                  loading={addItemThroughParticularCategoryItemLoader === index}
                  onClick={() =>
                    increseItemQuantityTroughParticularCategory(
                      item?.variant?.barcodes[0],
                      item?.variant?.name || item?.name,
                      index,
                      item?.variant?.needsWeighingScaleIntegration === true
                        ? "weighingScale"
                        : "Standard",
                      item?.variant?.weightUnit
                    )
                  }
                >
                  ADD
                </StyledButton>
              </div>
            </div>
          ))}
        </div>
      )}
      {openModalTwoway && (
        <div>
          <Modal open={openModalTwoway} onClose={handleModalClose}>
            <Box
              sx={{
                backgroundColor: color === "dark" ? "#353a50" : "#fff",
                color: color === "dark" ? "white" : "black",
                position: isMobile ? "static" : "relative",
                width: isMobile ? "100%" : "40%",
                maxWidth: "100vw",
                maxHeight: isMobile ? "100%" : "90%",
                transform: isMobile ? "none" : "translate(50%, -50%)",
                borderRadius: "10px",
                top: "50%",
                left: "10%",
                overflowY: "auto",
                ...(isMobile && {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }),
              }}
            >
              <div className="sticky-box-mrp">
                <div style={{ width: "100%" }}>
                  <IconButton sx={{ float: "right" }} onClick={handleModalClose}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </div>

                <div className="gtin-wrapper-box">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h5 className="text-mrp-heading" style={{ color: "gray" }}>
                      {selectedProduct} -&nbsp;
                    </h5>
                    <p style={{ color: "gray", fontWeight: "600" }}>{selectedGtin}</p>
                  </div>
                </div>
              </div>
              <div className="mrp-option-wrapper-box">
                <p>Batches</p>
                {mrps?.map((mrp, i) => (
                  <div key={i} className="select-mrp-wrapper-box">
                    <input
                      name="mrp"
                      key={mrp.mrp}
                      value={mrp.mrp}
                      id={`mrp-${i}`}
                      type="radio"
                      onChange={(e) =>
                        handlePrice(
                          mrp?.mrp,
                          mrp?.sellingPrice,
                          mrp?.batchNum,
                          mrp?.purchasePrice,
                          mrp?.offers
                        )
                      }
                    />
                    <div className="select-items-container">
                      <label style={{ cursor: "pointer" }} htmlFor={`mrp-${i}`}>
                        <p style={{ fontWeight: "bold" }}>
                          {mrp.mrp >= mrp.sellingPrice ? (
                            <b className="strike-off-mrp">&nbsp;{getStoreCurrencySymbol()}{mrp.mrp}&nbsp;</b>
                          ) : null}
                          <b>&nbsp;&nbsp;</b>{getStoreCurrencySymbol()}{mrp.sellingPrice}
                        </p>
                        <p className="select-item-details">Available Units : {mrp.quantity}</p>
                        <p className="select-item-details">Batch : {mrp.batch}</p>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mrp-popup-box">
                <button className="mrp-cancel-btn" onClick={handleModalClose}>
                  Cancel
                </button>
                <button
                  className="mrp-btn"
                  onClick={() => {
                    addItem(
                      selectedGtin,
                      selectedMrp,
                      SelectedSellingPrice,
                      batchNo,
                      purchasePrice,
                      offerData,
                      brandName,
                      packagingType,
                      variantName,
                      vendorId,
                      expiryDate,
                      sellingUnit
                    );
                  }}
                >
                  Select
                </button>
              </div>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
};

export default DropDownModal;
